import { ScaleDefinition } from '../../models/dynamic-scale.model';
import { SCALE_TYPE } from '../scale-type.enum';

export const SPPB_SCALE: ScaleDefinition = {
  idRef: SCALE_TYPE.SPPB,
  title: 'Short Physical Performance Battery (SPPB)',
  scoreConfig: {
    scoreKey: 'totale',
    scoreFields: ['equilibrio', 'cammino', 'chair_stand'],
  },
  sections: [
    {
      name: 'sppb',
      label: 'Short Physical Performance Battery',
      fields: [
        {
          key: 'equilibrio',
          label: 'Equilibrio statico',
          type: 'number',
          min: 0,
          max: 4,
          step: 1,
          maxScore: 4,
          valueDescriptions: {
            '0': 'Prestazione insufficiente (placeholder).',
            '1': 'Lieve stabilità / tempo minimo (placeholder).',
            '2': 'Stabilità discreta (placeholder).',
            '3': 'Buona stabilità (placeholder).',
            '4': 'Stabilità ottimale (placeholder).',
          },
          description:
            "Valutazione dell'equilibrio statico (testo ufficiale da inserire).",
        },
        {
          key: 'cammino',
          label: 'Velocità del cammino (4 metri)',
          type: 'number',
          min: 0,
          max: 4,
          step: 1,
          maxScore: 4,
          valueDescriptions: {
            '0': 'Prestazione insufficiente (placeholder).',
            '1': 'Velocità molto lenta (placeholder).',
            '2': 'Velocità lenta (placeholder).',
            '3': 'Velocità adeguata (placeholder).',
            '4': 'Velocità ottimale (placeholder).',
          },
          description:
            'Velocità di cammino su 4 metri (istruzioni da inserire).',
        },
        {
          key: 'chair_stand',
          label: 'Chair Stand Test (5 alzate)',
          type: 'number',
          min: 0,
          max: 4,
          step: 1,
          maxScore: 4,
          valueDescriptions: {
            '0': 'Non eseguibile (placeholder).',
            '1': 'Prestazione molto lenta (placeholder).',
            '2': 'Prestazione lenta (placeholder).',
            '3': 'Buona prestazione (placeholder).',
            '4': 'Prestazione ottimale (placeholder).',
          },
          description:
            'Test delle alzate dalla sedia (istruzioni ufficiali da inserire).',
        },
      ],
    },
  ],
  computedFields: [
    {
      key: 'totale',
      label: 'Punteggio totale',
      type: 'number',
      calculation: 'SUM(scoreConfig.sumOf)',
      maxScore: 12,
    },
  ],
};
